import React from 'react'
import PropTypes from 'prop-types'
import RemindersMessageReport from '../../common/RemindersMessageReport'
import css from '../../common/Form.css'

const RemindersMessageReports = ({
  onChange,
  messageReportEmail,
  additionalRecipients,
}) => (
  <div className={css.formGroup}>
    <h3>Reminders</h3>
    <RemindersMessageReport
      help="To subscribe, enter email, to unsubscribe, clear email."
      key="subscription"
      label="Message Report Subscription"
      name="messageReportEmail"
      onChange={onChange}
      placeholder="email@example.com"
      value={messageReportEmail}
    />
    <RemindersMessageReport
      help="Add additional recipients in comma separated list. To unsubscribe, clear all emails."
      key="additional-subscription"
      label="Additional Message Report Subscription Recipients"
      name="additionalRecipients"
      onChange={onChange}
      placeholder="first@example.com, second@example.com"
      value={additionalRecipients}
    />
  </div>
)

RemindersMessageReports.propTypes = {
  onChange: PropTypes.func.isRequired,
  messageReportEmail: PropTypes.string,
  additionalRecipients: PropTypes.string,
}

RemindersMessageReports.defaultProps = {
  messageReportEmail: null,
  additionalRecipients: null,
}

export default RemindersMessageReports



// WEBPACK FOOTER //
// ./src/AddPractice/Products/RemindersMessageReports.js